webpackJsonp([142040051024161],{

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Anatomy = __webpack_require__(10);
	
	var _Anatomy2 = _interopRequireDefault(_Anatomy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Anatomy2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'package-lock.json'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This file doesn\'t exist in new projects by default, but will be created the first time you run ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'npm install'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This is a "lock file" that describes ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'the specific version of each package that was installed'
	      ),
	      ' and (if committed to your git repository) guarantees that each person (or Continuous Integration server) that downloads the project will get the exact same configuration.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To learn more about this file, see the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://docs.npmjs.com/files/package-lock.json' },
	        'package.json documentation'
	      ),
	      ' on the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'npm'
	      ),
	      ' website.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-anatomy-package-lock-js-5529064996a04dac34d2.js